import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { createInstituteType } from '../api/instituteTypes.api';
import type { CreateInstituteTypePayload } from '../types/instituteType.types';

export function useCreateInstituteType(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (payload: CreateInstituteTypePayload) => createInstituteType(payload),
    onSuccess: () => {
      void refreshRelatedData('instituteType');
      toast.success('Institute type created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create institute type');
    },
  });
}
